import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-video',
  templateUrl: './icon-video.component.html',
  styles: []
})
export class IconVideoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
